<!--
 * @Descripttion: 
 * @version: v1
 * @Author: liukx
 * @Date: 2022-04-30 15:36:43
 * @LastEditors: ???
 * @LastEditTime: 2022-05-03 21:28:39
-->
<template>
  <div>
    <div class="dashboard-container">
      <span class="sys_name">欢迎使用瓦力后台管理系统</span>

      <img src="~@/assets/dashboard/banner.png" alt="" />
    </div>
    <div class="dashboard_security">
      <!-- <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备2022010694号-1</a> -->
      <img src="../../assets/police.png" alt="">
      <a
        href="https://beian.mps.gov.cn/#/query/webSearch?code=11011302007105\"
        rel="noreferrer"
        target="_blank"
        >京公网安备11011302007105</a
      >
      <a href="https://beian.miit.gov.cn/" target="_blank"
        >京ICP备2022010694号-1</a
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { loginFree } from "@/api/login";

export default {
  name: "Dashboard",
  data() {
    return {
      currentRole: "adminDashboard",
    };
  },
  computed: {
    ...mapGetters(["roles"]),
  },
  methods: {
    aaa() {
      loginFree({}).then((res) => {});
    },
  },
  created() {
    if (!this.roles.includes("admin")) {
      this.currentRole = "editorDashboard";
    }
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.dashboard-container {
  margin-top: 30px;
  display: flex;

  justify-content: center;
  align-items: center;
  flex-direction: column;
  img {
    width: 900px;
  }
  .sys_name {
    align-self: flex-start;
    font-size: 40px;
    text-align: left;
    color: #666;
    letter-spacing: 3px;
    margin-left: 50px;
  }
}
.dashboard_security {
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: #989fb0;
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  margin-left: 10px;
  img {
    width: 14px;
    height: 14px;
    margin-right: 5px;
  }
  a {
    margin-right: 10px;
  }
  a:hover {
    color: #409eff;
  }
}
</style>
